import pro1 from "../assets/proyecto_20kw.png"
import pro2 from "../assets/proyecto_girardot_10kw.png"
import pro3 from "../assets/proyecto_chia_cundinamarca.png"

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "20kw injection project",
        text: "This project",
        view: "https://video.xx.fbcdn.net/o1/v/t2/f2/m69/AQOfxWBy1ITVjzJ6e6niBhQ1_0LAyMBhC27pXmhjgPkWM23Fxol84vw0U9m9zLgtCuGQ1Bckudyk6KaAF0vOq_on.mp4?strext=1&_nc_cat=111&_nc_sid=8bf8fe&_nc_ht=video.xx.fbcdn.net&_nc_ohc=Vh4_-02G3QUQ7kNvwFQZzeB&efg=eyJ2ZW5jb2RlX3RhZyI6Inhwdl9wcm9ncmVzc2l2ZS5GQUNFQk9PSy4uQzMuMzYwLnN2ZV9zZCIsInhwdl9hc3NldF9pZCI6MTIxNjQ5NTY4OTU3NDE1MywidmlfdXNlY2FzZV9pZCI6MTAxMzksImR1cmF0aW9uX3MiOjIxLCJ1cmxnZW5fc291cmNlIjoid3d3In0%3D&ccb=17-1&_nc_zt=28&oh=00_AfMnAUxyCVxocarclXGykwlhOSN-gZoGEtY7lD50wpJnRA&oe=684D4FEB"
    },

    {
        imgsrc: pro2,
        title: "Girardot 10kw Project",
        text: "This project",
        view: "https://video.xx.fbcdn.net/o1/v/t2/f2/m69/AQO8q8JU_NIRF9Ffw5dWRSZprEmcyfHGUVtZjc9Fc6cvF7Vv_H1WGs7_BxBYFxg4Tst-9_kBAVi3cgri_vvzykcp.mp4?strext=1&_nc_cat=111&_nc_sid=8bf8fe&_nc_ht=video.xx.fbcdn.net&_nc_ohc=T6f9QXXGANMQ7kNvwEfeOX0&efg=eyJ2ZW5jb2RlX3RhZyI6Inhwdl9wcm9ncmVzc2l2ZS5GQUNFQk9PSy4uQzMuMzU0LnN2ZV9zZCIsInhwdl9hc3NldF9pZCI6ODY4NjMwNzU1MDUxNDc4LCJ2aV91c2VjYXNlX2lkIjoxMDEzOSwiZHVyYXRpb25fcyI6MjIsInVybGdlbl9zb3VyY2UiOiJ3d3cifQ%3D%3D&ccb=17-1&_nc_zt=28&oh=00_AfOfsSLLwASFalkdhEd9wufNOXyWu24pbTra7UtPoZXIoQ&oe=684D59E3"
    },

    {
        imgsrc: pro3,
        title: "Project in Chia, Cundinamarca",
        text: "This project",
        view: "https://video.xx.fbcdn.net/o1/v/t2/f2/m69/AQO4_AghlzDrcSm-XYUqSYCl3zlRGI90ym4cwJDcRzl1Y9o49hcxnjzKKOIATg_HEvmiglnkGKFdwuktLukAAAyb.mp4?strext=1&_nc_cat=103&_nc_sid=8bf8fe&_nc_ht=video.xx.fbcdn.net&_nc_ohc=XkS56VNtWUYQ7kNvwEHuAXA&efg=eyJ2ZW5jb2RlX3RhZyI6Inhwdl9wcm9ncmVzc2l2ZS5GQUNFQk9PSy4uQzMuMzYwLnN2ZV9zZCIsInhwdl9hc3NldF9pZCI6NTE2NTM2MTQxMjgzMDYwLCJ2aV91c2VjYXNlX2lkIjoxMDEzOSwiZHVyYXRpb25fcyI6MTAsInVybGdlbl9zb3VyY2UiOiJ3d3cifQ%3D%3D&ccb=17-1&_nc_zt=28&oh=00_AfNB0PzhDrmx9fS43kct44artw6inICdiREYVgUb8Gq90g&oe=684D458B"
    }
]

export default ProjectCardData;